import React, { useRef, useState } from 'react';
import { Button } from '@material-ui/core';

import BasicModal from 'components/common/modal/BasicModal';

import ModalContent from './modalContent';

interface Props {
  userId: string;
  isOpen: boolean;
  closeModal: () => void;
}

const AddCouponModal = ({ userId, isOpen, closeModal }: Props) => {
  const modalContentRef = useRef<{ saveNewCoupon: () => void } | null>(null);

  const [isDisabled, setIsDisabled] = useState<boolean>(false);

  const saveNewCoupon = () => {
    if (modalContentRef?.current) {
      modalContentRef.current.saveNewCoupon();
    }
  };

  const checkValidation = (isValid: boolean) => {
    setIsDisabled(isValid);
  };

  return (
    <>
      <BasicModal
        open={isOpen}
        onClose={() => closeModal()}
        title={'Add Coupon'}
        actionButton={
          <>
            <Button variant={'text'} color={'primary'} onClick={() => closeModal()}>
              Cancel
            </Button>
            <Button
              variant={'text'}
              color={'primary'}
              onClick={saveNewCoupon}
              disabled={isDisabled}
            >
              Confirm
            </Button>
          </>
        }
      >
        <ModalContent
          userId={userId}
          onRequiresValidation={checkValidation}
          closeModal={closeModal}
          ref={modalContentRef}
        />
      </BasicModal>
    </>
  );
};
export default AddCouponModal;
